import {createViewConfig} from '@sail/engine';
import type {DrawerProps} from './DrawerProps';

export const DrawerConfig = createViewConfig({
  props: {} as DrawerProps,
  name: 'Drawer',
  flattens: true,
});
